import Vue from "vue";
import axios from "axios";
import {
    CREATE_USER,
    FETCH_USER,
    RESET_USER,
    UPDATE_USER,
    UPDATE_USER_PERMISSIONS
} from "./actions.type";
import { UserService } from "../../common/user.service";

const state = {
    status: "",
    profile: {}, // logged user
    user: {}
};

const getters = {
    getProfile: state => state.profile,
    isProfileLoaded: state => !!state.profile.name,
    user(state) {
        return state.user;
    }
};

const actions = {
    userRequest: ({ commit, dispatch }) => {
        commit("userRequest");
        axios
            .get(process.env.VUE_APP_BASE_URI + "/api/user")
            .then(resp => {
                commit("userSuccess", resp.data);
            })
            .catch(err => {
                alert(err);
                commit("userError");
                // if resp is unauthorized, logout, to
                dispatch("authLogout");
            });
    },
    [CREATE_USER]({ state }) {
        return UserService.create(state.user);
    },
    [UPDATE_USER]({ state }) {
        return UserService.update(state.user.id, state.user);
    },
    [FETCH_USER]({ commit }, params) {
        commit("resetUser");
        return UserService.get(params.id)
            .then(({ data }) => {
                commit("fetchUserSuccess", data);
            })
            .catch(error => {
                throw new Error(error);
            });
    },
    [UPDATE_USER_PERMISSIONS]({ state }) {
        return UserService.updatePermissions(
            state.user.id,
            state.user.actualPermissions
        );
    },
    [RESET_USER]({ commit }) {
        commit("resetUser");
    }
};

const mutations = {
    userRequest: state => {
        state.status = "loading";
    },
    userSuccess: (state, resp) => {
        state.status = "success";
        Vue.set(state, "profile", resp);
    },
    userError: state => {
        state.status = "error";
    },
    fetchUserSuccess: (state, resp) => {
        let actual = resp.permissions.map(item => {
            return item.id;
        });
        resp.actualPermissions = actual || [];
        state.user = resp;
    },
    resetUser: state => {
        state.user = {};
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
